import { Alert, spaceMixin } from '@zillow/constellation';
import React from 'react';
import styled from 'styled-components';

var StyledErrorBox = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-14hyed0-0"
})(["margin:", " auto;"], function (_ref) {
  var hideTopMargin = _ref.hideTopMargin;
  return hideTopMargin ? 0 : spaceMixin('sm');
});
var ErrorBox = function ErrorBox(_ref2) {
  var errorMessage = _ref2.errorMessage,
    _ref2$hideTopMargin = _ref2.hideTopMargin,
    hideTopMargin = _ref2$hideTopMargin === void 0 ? false : _ref2$hideTopMargin;
  return /*#__PURE__*/React.createElement(StyledErrorBox, {
    hideTopMargin: hideTopMargin
  }, /*#__PURE__*/React.createElement(Alert, {
    appearance: "error",
    body: errorMessage
  }));
};
var ErrorBox$1 = ErrorBox;

export { ErrorBox$1 as default };
